import React, { Component } from "react";

class Stats extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return <p>Not yet implemented</p>;
    }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/container/stats/Stats.js